module.exports = __webpack_public_path__ + "img/icon-eel.286f35ab.svg";